<template>
    <div class="page">
        <el-scrollbar class="Yscrollbar" style="height:calc(100% - 8vh);">
            <LabelContent :title="$t('menu.person')" />
            <el-form label-width="100px" class="u-form" size="small">
                <el-form-item :label="$t('base.name')">
                    <el-input :placeholder="$t('base.PleaseEnter')" v-model="userInfo.userName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.phone')">
                    <el-input :placeholder="$t('base.PleaseEnter')" v-model="userInfo.userPhone"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.email')">
                    <el-input :placeholder="$t('base.PleaseEnter')" v-model="userInfo.userEmail"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="long" @click="updateUserInfo" type="primary" size="small">{{$t('menu.ChangeInfo')}}</el-button>
                </el-form-item>
            </el-form>
            <LabelContent :title="$t('base.changePassword')" />
            <el-form label-width="100px" class="u-form" size="small">
                <el-form-item :label="$t('base.oldPassword')">
                    <el-input :type="oldPwdShow ? 'password' : 'text'" v-model="opwd" :placeholder="$t('base.PleaseEnter')">
                        <i slot="suffix" class="iconfont" :class="oldPwdShow ? 'u-bukejian' : 'u-kejian'" @click="oldPwdShow = !oldPwdShow" />
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('base.newPassword')">
                    <el-input :type="newPwdShow ? 'password' : 'text'" v-model="npwd" :placeholder="$t('base.PleaseEnter')" @input="checkPwdStrength">
                        <i slot="suffix" class="iconfont" :class="newPwdShow ? 'u-bukejian' : 'u-kejian'" @click="newPwdShow = !newPwdShow" />
                    </el-input>
                </el-form-item>
                <!-- 密码强度指示器 -->
                <el-form-item v-if="npwd" label="密码强度">
                    <div class="pwd-strength">
                        <div class="strength-bar">
                            <div :class="['bar', strengthLevel >= 0 ? 'active' : '', 'level-' + strengthLevel]"></div>
                            <div :class="['bar', strengthLevel >= 1 ? 'active' : '', 'level-' + strengthLevel]"></div>
                            <div :class="['bar', strengthLevel >= 2 ? 'active' : '', 'level-' + strengthLevel]"></div>
                        </div>
                        <span class="strength-text">{{ strengthText }}</span>
                    </div>
                </el-form-item>
                <!-- 密码规则提示 -->
                <el-form-item>
                    <div class="pwd-rules">
                        <p :class="npwd.length >= 8 ? 'rule-pass' : 'rule-fail'">✓ 至少8位字符</p>
                        <p :class="checkKinds() >= 3 ? 'rule-pass' : 'rule-fail'">✓ 包含大写字母、小写字母、数字、特殊字符中的至少3种</p>
                        <p :class="!npwd || !npwd.toLowerCase().includes(userInfo.userAccount?.toLowerCase()) ? 'rule-pass' : 'rule-fail'">✓ 不能包含用户名</p>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button @click="updatePwd" type="primary">{{$t('base.changePassword')}}</el-button>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <!-- <div class="bottomBtnBox">
            <el-button class="long" @click="updateUserInfo" type="primary" size="small">修改信息</el-button>
        </div> -->
    </div>
</template>
<script>
import { editUser, editUserPassword } from '../../libs/api'
export default {
    name: 'Factory',
    data() {
        return {
            //密码不可见控制
            oldPwdShow: true,
            newPwdShow: true,
            userInfo: {},
            opwd: '',
            npwd: '',
            strengthLevel: 0,
            strengthText: ''
        }
    },
    mounted() {
        // this.userInfo = this.$store.state.userInfo
        this.getUserInfo()
    },
    methods: {
        getUserInfo() {
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            let options = {
                url: this.$api.findUserById,
                method: 'GET',
                params: {userId:userInfo.userId}
            }
            this.$http.request(options).then(resp => {
                    if (resp.status == 100) {
                        this.userInfo = resp.data
                        delete this.userInfo.userPasswd
                    }
                })
                .catch(() => {})
        },
        test() {},
        updatePwd() {
            if (this.opwd && this.npwd) {
                if (this.npwd.length >= 8) {
                    this.$http
                        .request({
                            url: this.$api.editUserPassword,
                            method: 'POST',
                            showLoading: true,
                            params: {
                                oldPassWord: this.opwd,
                                newPassWord: this.npwd
                            }
                        })
                        .then(resp => {
                            if (resp.status == 100) {
                                this.$message.success(this.$t('base.SuccessfullyUpdated'))
                                this.opwd = ''
                                this.npwd = ''
                                this.strengthLevel = 0
                                this.strengthText = ''
                                this.getUserInfo()
                            } else {
                                this.$message.error(resp.message)
                            }
                        })
                } else {
                    this.$message.error(this.$t('menu.Password') + '，密码至少8位')
                }
            } else {
                this.$message.error(this.$t('menu.empty'))
            }
        },
        checkPwdStrength() {
            if (!this.npwd) {
                this.strengthLevel = 0
                this.strengthText = ''
                return
            }
            let kinds = 0
            if (/[A-Z]/.test(this.npwd)) kinds++
            if (/[a-z]/.test(this.npwd)) kinds++
            if (/[0-9]/.test(this.npwd)) kinds++
            if (/[^a-zA-Z0-9]/.test(this.npwd)) kinds++

            if (this.npwd.length >= 12 && kinds === 4) {
                this.strengthLevel = 2
                this.strengthText = '强'
            } else if (this.npwd.length >= 8 && kinds >= 3) {
                this.strengthLevel = 1
                this.strengthText = '中'
            } else {
                this.strengthLevel = 0
                this.strengthText = '弱'
            }
        },
        checkKinds() {
            if (!this.npwd) return 0
            let kinds = 0
            if (/[A-Z]/.test(this.npwd)) kinds++
            if (/[a-z]/.test(this.npwd)) kinds++
            if (/[0-9]/.test(this.npwd)) kinds++
            if (/[^a-zA-Z0-9]/.test(this.npwd)) kinds++
            return kinds
        },
        updateUserInfo() {
            if(this.userInfo.userName == null || this.userInfo.userName == '' || this.userInfo.userName == undefined){
                this.$message.error(this.$t('User.name'))
                return
            }
            let options = {
                method: 'POST',
                data: this.userInfo,
                url: this.$api.editUserInfo
            }
            this.$http.request(options).then(response => {
                    if (response.status != 100) {
                        this.$message.error(response.message)
                    }
                    this.getUserInfo()
                    this.$message.success(this.$t('base.SuccessfullyUpdated'))
                })
                .catch(err => {
                    this.$message.error(err)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.pwd-strength {
    display: flex;
    align-items: center;
    gap: 10px;
    .strength-bar {
        display: flex;
        gap: 4px;
        .bar {
            width: 50px;
            height: 6px;
            border-radius: 3px;
            background: #e0e0e0;
            &.active.level-0 { background: #f56c6c; }
            &.active.level-1 { background: #e6a23c; }
            &.active.level-2 { background: #67c23a; }
        }
    }
    .strength-text {
        font-size: 12px;
        color: #909399;
    }
}
.pwd-rules {
    p {
        margin: 3px 0;
        font-size: 12px;
    }
    .rule-pass { color: #67c23a; }
    .rule-fail { color: #909399; }
}
</style>
